"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// require("src/tokens/index.css");

function _clear () {
    this.innerHTML = "";
}

class InlineMessage extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);

        // _clear.bind(this);
    }

    static get observedAttributes() {
        return [
            "state",
            "message"
        ];
    }

    connectedCallback() {
        const state = this.getAttribute("state");
        if (state) {
            this.addIcon(state);
        }
        if (this.innerHTML) {
            this.addMessage(this.innerHTML);
            // const icon = document.createElement("swiftref-icon");
            // icon.setAttribute("kind", this.state);
            // const label = document.createElement("label");
            // label.innerHTML = this.innerHTML;
            // this.root.appendChild(icon);
            // this.root.appendChild(label);
        }
        // clearTimeout(this.timeoutId);
        // this.timeoutId = setTimeout(_clear, 1);
    }

    addIcon(iconType) {
        let icon = this.root.querySelector("swiftref-icon");
        if (!icon) {
            icon = document.createElement("swiftref-icon");
            this.root.prepend(icon);
        }
        icon.setAttribute("kind", iconType);
    }
    removeIcon() {
        try {
            let icon = this.root.querySelector("swiftref-icon");
            this.root.removeChild(icon);
        } catch (e) {}
    }
    addMessage(message) {
        let label = this.root.querySelector("label");
        if (!label) {
            label = document.createElement("label");
            this.root.appendChild(label);
        }
        label.innerText = message;
    }


    attributeChangedCallback(name, oldVal, newVal) {
        switch (name) {
            case "state":
                if (newVal) {
                    this.addIcon(newVal);
                } else {
                    this.removeIcon();
                }
                break;
            case "message":
                this.addMessage(newVal);
                break;
            default:
                break;
        }
    }


}

window.customElements.define("swiftref-message", InlineMessage);

module.exports = InlineMessage;
